// extracted by mini-css-extract-plugin
module.exports = {"ContactVerificationIcon":"Icons_ContactVerificationIcon_1Zeir"};